import React from "react";
import * as S from "./styled.js";

const ChartPessoas = ({ valor = 10 }) => {
  const totalIcons = 100; // Total de ícones (10x10)
  const activeIcons = Math.round(((valor || 0) / 100) * totalIcons); // Garante que valor seja válido

  return (
    <S.Grid>
      {Array.from({ length: totalIcons }, (_, index) => (
        <S.Icon key={index} active={index < activeIcons} />
      ))}
    </S.Grid>
  );
};


export default ChartPessoas;
